import React, { useEffect, useState } from "react";
import './driver-list.css'
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DataDriverTable from "../../components/Data-driver-table/data-driver-table";
import { Button } from "antd";
import AddIcon from '@mui/icons-material/Add';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { getDriversFromCache, subscribeDriversCache } from "../../service/driver-cache.service";
require('firebase/auth')

function DriverList(){
    
    const [drivers, setDrivers] = useState([]);

    const [cleanFilters, setCleanFilters] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

    const user = useSelector(state => state.user);

    useEffect(() => {
        // 1) Tenta preencher a tela instantaneamente com o cache atual.
        const cacheSnapshot = getDriversFromCache();
        if (cacheSnapshot.hasLoadedOnce) {
            setDrivers(cacheSnapshot.data);
        }

        // 2) Mantém a tela sincronizada com mudanças do banco em tempo real.
        const unsubscribe = subscribeDriversCache(({ data }) => {
            setDrivers(data);
        });

        // 3) Cleanup ao desmontar para evitar vazamento de listener.
        return () => {
            unsubscribe();
        };
    }, []);

    return (
        <>
    { 
        useSelector(state => state.usuarioLogado) > 0 ?
            <NewMiniDrawer divOpen={
                <div className="freight-content">
                    <div className="container" style={{ marginBottom: "10px", marginLeft: 0 }}>
                        <div id="rowWrap" className="row">
                            <div className="col-6">
                                <h3>Motoristas</h3>
                            </div>
                            <div className="col-3"></div>
                            <div className="col-1">
                                {
                                    user?.permissoes?.driver?.isCreate || user?.permissoes?.motorista?.cadastrar ? 
                                    (
                                        <Link to={"/driver"}>
                                            <Button id="ButtonHover" type="primary" icon={<AddIcon />}>
                                                Novo
                                            </Button>
                                        </Link>
                                    )
                                    :
                                    (
                                        ""
                                    )
                                }
                            </div>
                            <div className="col-1">
                                <Button
                                type="primary"
                                onClick={() => setCleanFilters(!cleanFilters)}
                                className="btn-limpar-filtros"
                                >
                                    Limpar Filtros
                                </Button>
                            </div>
                            <div 
                                style={{ marginLeft: "1.5%" }} 
                                className="col-1"
                                onClick={() => setOpenFilters(!openFilters)}
                            >
                                <Button >
                                    Filtros Salvos
                                </Button>
                            </div>
                        </div>
                    </div>

                    <DataDriverTable
                        data={drivers}
                        cleanFilters={cleanFilters}
                        openFilters={openFilters}
                        onCleanFilterHandled={() => setCleanFilters(false)}
                        onOpenFilterHandled={() => setOpenFilters(false)}
                    />

                </div>
        }/>
        : 
        <Navigate to='/login' />
    }
    </>
    );
}


export default DriverList;